var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.68,
    height: 7.462,
    viewBox: "0 0 13.68 7.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Down_Arrow_3_",
    d: "M26.84,47.461a.62.62,0,0,1-.44-.182l-6.218-6.218a.622.622,0,0,1,.879-.879L26.84,45.96l5.778-5.778a.622.622,0,0,1,.879.879l-6.218,6.218A.62.62,0,0,1,26.84,47.461Z",
    transform: "translate(-20 -40)",
    fill: "#8a8a8a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowGray);
export default __webpack_public_path__ + "static/media/DownArrowGray.d4c28d501fe2e61164d9712ffff4f59b.svg";
export { ForwardRef as ReactComponent };